import React from 'react';

function ranchMap(props) {
    const {
        posts
    } = props;

    const filterEvent = new Event('filterMap');

    const markers = posts.map((post) => {
        if ( post.acf.ranch_map ) {
            return (
                <div key={post.id} className="marker" data-lat={post.acf.ranch_map.lat} data-lng={post.acf.ranch_map.lng}>
                    <p dangerouslySetInnerHTML={{__html: post.title.rendered}}></p>
                </div>
            );
        }
    });

    setTimeout(() => {
        document.dispatchEvent(filterEvent);
    }, 100);

    return (
        <section className="ranch-mapz ranch-map--filters" id="map">
            <div className="container">
                <div className="ranch-map__wrapper">
                    <div className="ranch-map__markers acf-map-markers">
                        {markers}
                    </div>
                    
                </div>
            </div>
        </section>
    );
}

export default ranchMap;